import { useContext } from 'react';
import { Toaster } from 'react-hot-toast';
import Router from 'src/routes/sections';

import { AuthContext } from 'src/auth/context';
import { useAxiosAuthInterceptor } from 'src/hooks/useAxiosAuthInterceptor';
import { MaintenanceGate } from 'src/auth/guard';

const App = () => {
  const { logout, loading } = useContext(AuthContext);

  useAxiosAuthInterceptor(logout, loading);

  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerStyle={{
          top: 90,
          right: 16,
        }}
      />

      <MaintenanceGate>
        <Router />
      </MaintenanceGate>
    </>
  );
};

export default App;
